import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="back-nav"
export default class extends Controller {
  go(event) {
    // Prefer browser history for correct multi-step back behavior.
    if (window.history && window.history.length > 1) {
      event.preventDefault()
      // Use Turbo-friendly history navigation (works with Turbo too)
      window.history.back()
    }
    // Otherwise, let the link navigate to its href (fallback path)
  }
}

